import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { type SheetContentProps } from '@/components/sheet/sheet'

import { useResizeWindow } from '@/lib/hooks/use-resize-window'

import { type PortalControlSheetProps } from './portal-control-sheet'
import { type ClientPortalOptionForm } from './types'

export type UsePortalControlSheetParams = Pick<PortalControlSheetProps, 'isOpen' | 'defaultPortalOption'>

export const usePortalControlSheet = ({ isOpen, defaultPortalOption }: UsePortalControlSheetParams) => {
  const { width: windowWidth } = useResizeWindow()

  const form = useForm<ClientPortalOptionForm>()

  const sheetSide: SheetContentProps['side'] = windowWidth < 1024 ? 'bottom' : 'right'
  const isDisabledSaveButton = !form.formState.isDirty

  useEffect(
    function resetToDefaultFormValues() {
      if (!isOpen || defaultPortalOption) {
        form.reset(defaultPortalOption)
      }
    },
    [form, isOpen, defaultPortalOption]
  )

  useEffect(
    function setDirtyToDefaultSetting() {
      const isSettingsDirty =
        form.getFieldState('processingTime').isDirty ||
        form.getFieldState('processingTimeTrend').isDirty ||
        form.getFieldState('inquiryDateTrend').isDirty ||
        form.getFieldState('visaBulletin').isDirty ||
        form.getFieldState('visaBulletinTrend').isDirty ||
        form.getFieldState('alertSchedule').isDirty

      if (isSettingsDirty) {
        form.setValue('isDefaultSetting', false)
      }
    },
    [form, form.formState.isDirty]
  )

  return { form, sheetSide, isDisabledSaveButton }
}
